export default __webpack_public_path__ + "static/media/ic_person_history.5c132d3e.png";